export default "__VITE_ASSET__ByQiaVPr__"